import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FaCheckCircle,
  FaChartLine,
  FaLightbulb,
  FaUsers,
  FaFilePdf,
  FaExclamationTriangle,
  FaQuoteLeft,
  FaHistory,
} from "react-icons/fa";
import { FaArrowLeft } from "react-icons/fa6";
import "./ValidationBenefit.css";

const ValidationBenefit = () => {
  const navigate = useNavigate();
  

  const benefits = [
    { icon: <FaCheckCircle />, title: "Proof of Validation", desc: "Builds founder & investor confidence with evidence-based scoring" },
    { icon: <FaChartLine />, title: "Investor Readiness Snapshot", desc: "Shows your stage & readiness level instantly" },
    { icon: <FaLightbulb />, title: "Actionable Insights", desc: "Pinpoints strengths, gaps, and next steps for improvement" },
    { icon: <FaUsers />, title: "Sector & Investor Fit", desc: "Matches your idea to the right domain and funding ecosystem" },
    { icon: <FaFilePdf />, title: "Professional Report (PDF)", desc: "Ready-to-share visual summary for pitches & incubator entries" },
    { icon: <FaExclamationTriangle />, title: "Risk Reduction", desc: "Identifies early weaknesses before scaling or investment" },
    { icon: <FaQuoteLeft />, title: "Pitch Confidence", desc: 'Adds credibility — "Validated by Marsmate AI."' },
    { icon: <FaHistory />, title: "Progress Tracking", desc: "Compare revalidation scores over time to show growth" },
  ];

 

  return (
    <div className="v-benefit-page">
      <div className="v-top-nav">
        <button className="v-back-link" onClick={() => navigate("/scorecard")}>
  <FaArrowLeft /> Back
</button>
      </div>

      <div className="v-benefit-card">
        <div className="v-heading-container">
          <span className="v-bulb-large">💡</span>
          <h1 className="v-heading-text">
            Why You Should Download a<br className="desktop-br" /> Idea Validation Report
          </h1>
        </div>

        <p className="v-intro">
          A Idea Validation Report (like the Marsmate Validation Report) is not just a document — 
          it’s your evidence-based readiness scorecard for founders, mentors, and investors.
        </p>

        <div className="v-table-responsive">
          <table className="v-table">
            <thead>
              <tr>
                <th className="v-col-adv">Advantage</th>
                <th className="v-col-why">Why It Matters</th>
              </tr>
            </thead>
            <tbody>
              {benefits.map((b, i) => (
                <tr key={i}>
                  <td className="v-first-col">
                    <span className="v-icon">{b.icon}</span>
                    <strong className="v-benefit-title">{b.title}</strong>
                  </td>
                  <td className="v-second-col">{b.desc}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ValidationBenefit;